module.exports = __webpack_public_path__ + "img/avatar5.77d8e3b8.png";